<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Cancel Member
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
    </div>
    <div class="ac-body-container">
      <div class="ac-cancel-warning">
        Are you sure you want to cancel this member?
      </div>
      <div class="ac-cancel-warning">
        This will cancel all the subscriptions if member has
        any and mark all their devices as 'Cancelled'.
      </div>
      <ProcessOverlay
        :show="cancellingSubscription"
        text="Cancelling subscription"
        overlayClass="ac-overlay"
      />
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-cancel-button"
        @click="cancelSubscription()"
      >
        Yes
      </button>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'CancelSubscriptions',
  mixins: [customerDetailMixin],
  components: {
    ProcessOverlay,
  },
  data() {
    return {
      selected: undefined,
      newSubs: [],
    };
  },
  mounted() {
    this.newSubs = this.subscription.map((s) => {
      s.checked = false;
      return s;
    });
    this.newSubs = this.subscription.length
      && [...this.subscription, { planId: 'all', stripeSubscriptionId: 'all', description: 'All' }];
  },

  methods: {
    async cancelSubscription() {
      await this.$store.dispatch('cancelSubscription');
      await Promise.all([
        this.$store.dispatch('getAllCustomers'),
        this.$store.dispatch('getAllDeactivatedCustomers'),
        this.$store.dispatch('getPartnerCustomerCount'),
        this.$store.dispatch('getNotOnboardedCustomers'),
      ]);
    },
  },
};
</script>
